import { Injectable } from '@angular/core'
import { OrdersService } from '../orders.service'
import { BehaviorSubject } from 'rxjs'
import { SettingsService } from '../../settings/settings.service'
import { ToastService } from 'src/app/pages/toastr/toast.service'

@Injectable({
  providedIn: 'root'
})
export class OrderNotificationService {
  private previousOrdersCount = 0
  private newOrderSubject = new BehaviorSubject<boolean>(false)
  private initialized = false
  private notificationSound = new Audio('/assets/sounds/new-order-notification.mp3')
  private isSoundMuted: boolean = false;

  constructor(
    private ordersService: OrdersService,
    private SettingsService: SettingsService,
    private toastService: ToastService
  ) {
    const savedMute = localStorage.getItem('orderSoundMuted');
    this.isSoundMuted = savedMute === 'true';
    const savedOrdersCount = sessionStorage.getItem('previousOrdersCount')
    if (savedOrdersCount) {
      this.previousOrdersCount = Number(savedOrdersCount)
    }
    this.initializeOrdersCount()

    setInterval(() => {
      this.checkForNewOrders()
    }, 60000)
  }

  private initializeOrdersCount() {
    this.ordersService.fetchCount().subscribe((count: number) => {
      this.previousOrdersCount = count
      this.initialized = true
    })
  }

  setMuteSound(mute: boolean) {
    this.isSoundMuted = mute;
    localStorage.setItem('orderSoundMuted', String(mute));
  }

  getMuteState() {
    return this.isSoundMuted;
  }

  checkForNewOrders() {
    if (!this.initialized) return
    this.ordersService.fetchCount().subscribe((count: number) => {
      if (count > this.previousOrdersCount) {
        this.playNotificationSound()
        this.ordersService.fetchPage(0, 1).subscribe((orders: any[]) => {
          const latest = orders?.[0]
          this.toastService.initiate({
            type: 'order',
            title: 'New Order',
            content: 'A new order has been received!',
            imgPath: '/favicon.png',
            orderId: latest?.humId ? String(latest.humId) : undefined,
            total: latest?.total ?? undefined,
            currency: this.SettingsService.currency,
            onClick: () => {
              window.location.href = `/orders`
            }
          })
        })
        this.newOrderSubject.next(true)
      }

      this.previousOrdersCount = count
      sessionStorage.setItem('previousOrdersCount', String(count))
    })
  }

  getNewOrderNotification() {
    return this.newOrderSubject.asObservable()
  }

  private playNotificationSound() {
    if (this.isSoundMuted) return;
    this.notificationSound.load()
    this.notificationSound.play().catch((error) => {
      console.error('Error playing notification sound:', error)
    })
  }
}
